module.exports = __webpack_public_path__ + "static/app-shot-n-1-4-fe219140d8ddd03acc6ca4b0d87f76d4.png";